module.exports = __webpack_public_path__ + "static/media/DSC_6694.00a8fe73.jpg";